export default "/images/icons8-japan.png?de8cf2d13c16b7a6f318fbfa145ebfb7";